<template>
  <div id="app">
    <div class="hamburger-float" @click="openSidebar()">
      <label class="hamburger">
        <span class="navicon"> </span>
      </label>
    </div>
    <div class="wrapper">
      <Sidebar v-if="this.$route && this.$route.params && this.$route.params.groups" ref="sidebar" />
      <div class="rightWrapper">
        <!--<canvas class="snow" id="snow" width="2560" height="1440"></canvas>-->
        <router-view />
      </div>
    </div>
  </div>
</template>

<style>
html {
  height: 100%;
}
body {
  height: 100%;
}
table {
  width: 100%;
}

table tr th {
  background-color: transparent;
}

.buttonsGroup {
  display: inline-block;
  margin: 10px 0px;
}

.header {
  display: inline-block;
  font-size: 2em;
}

label {
  width: unset;
  float: unset;
  text-align: unset;
  margin-right: unset;
  line-height: unset;
}

.b-table .table tr.detail .detail-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.field.latitude {
  display: inline-block;
  width: 45%;
}

.field.longitude {
  display: inline-block;
  width: 45%;
  float: right;
}

.flex-gap-20 {
  gap: 20px;
}

.flex-gap-10 {
  gap: 10px;
}

#main-row {
  min-height: auto;
}

div.container {
  min-height: 40%;
}

html {
  background-color: unset;
}

.title {
  font-size: 1.2em;
}

div#app {
  height: 100%;
}

.wrapper {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.rightWrapper {
  overflow-y: auto;
  flex: 1;
  background-color: #dbdbdb;
}

html {
  overflow-y: hidden !important;
}

.flex-gap-10 {
  gap: 10px;
}
.flex-gap-20 {
  gap: 20px;
}
.height-100 {
  height: 100%;
}
</style>

<script>
import Navbar from "@/views/NavbarView.vue";
import Sidebar from "@/views/SidebarView.vue";
export default {
  components: {
    Navbar,
    Sidebar,
  },
  methods: {
    openSidebar: function () {
      this.$refs.sidebar.isOpen = !this.$refs.sidebar.isOpen;
    },
  },
};
</script>

<style scoped>
#snow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  pointer-events: none;
}
.hamburger-float {
  position: absolute;
  top: 10px;
  left: 0;
  background-color: #47d061;
  height: 40px;
  padding: 30px 20px;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

.hamburger .navicon {
  background: rgb(255, 255, 255);
  display: block;
  height: 2px;
  position: relative;
  transition: background 0.2s ease-out;
  width: 35px;
}
.hamburger .navicon:before,
.hamburger .navicon:after {
  background: rgb(255, 255, 255);
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  transition: all 0.2s ease-out;
  width: 100%;
}
.hamburger .navicon:before {
  top: 10px;
}
.hamburger .navicon:after {
  top: -10px;
}
.mobile-nav {
  display: none;
}

@media screen and (max-width: 768px) {
  .hamburger-float {
    position: absolute;
    top: 10;
    left: 0;
    z-index: 98;
  }
  .hamburger-float .hamburger {
    position: relative;
  }
}

@media screen and (max-width: 768px) {
  .rightWrapper {
    padding-top: 30px;
  }
}
</style>
